import React,{useState} from "react";
import edit_icon from "../assets/Images/edit.png";
import delete_icon from "../assets/Images/delete.png";
import close_icon from "../assets/Images/close_small_portfolio.svg";
import more_vert from "../assets/Images/more_vert_portfolio.svg";
import { BillingAddress } from "../types/types";
import { useNavigate } from "react-router-dom";
import {useBillingAddresseslMutation,useBillingAddressesDeleteMutation} from '../services/AsaApiServices'
import ConfirmDialog from "../components/ConfirmDialog ";
import showAsaToast from "../components/AsaToast";
import { useTranslation } from "react-i18next";
import { Config } from "../Utils/AppConstants";
interface BillingAddressCardProps {
  address: BillingAddress;
  isSelected: boolean;
  isSelectable: boolean;
  onSelect: (address: BillingAddress) => void | undefined;
  buttonColor:string|undefined
}
const vertPoints=(isDarkMode:boolean)=>{
  var fillColor=isDarkMode?"#FFFFFF":"#4E4E4E"
  return(
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  
  <circle cx="12" cy="5" r="2" fill={fillColor}/>
  <circle cx="12" cy="12" r="2" fill={fillColor}/>
  <circle cx="12" cy="19" r="2" fill={fillColor}/>
</svg>

)}
const closePoints=(isDarkMode:boolean)=>{
  var strokeColor=isDarkMode?"#FFFFFF":"#4E4E4E"
  return(
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<line x1="18.364" y1="5.63604" x2="5.63604" y2="18.364" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<line x1="18.364" y1="18.364" x2="5.63604" y2="5.63604" stroke={strokeColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}
const BillingAddressCard: React.FC<BillingAddressCardProps> = ({
  address,
  isSelected,
  isSelectable,
  onSelect,
  buttonColor
}) => {
  const { t } = useTranslation();
  const [isEditMode, setIsEditMode] = useState<boolean>(false );
  const navigate = useNavigate();
  const billinAddressDeleteMutation=useBillingAddressesDeleteMutation()
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const isDarkMode=document.body.classList.contains('dark');
  const handleConfirmedDelete = async () => {
      try {
        const billingAddressToDelete =address;
        setShowConfirmDialog(false) 
        const requestData = {
            consumerAddressId: billingAddressToDelete.consumerAddressId
        }
        

        try {
           await billinAddressDeleteMutation.mutateAsync(requestData)
        } catch (error) {
          if (error instanceof Error) {
            showAsaToast(error.message, true);
          }
        } finally {
          
        }
      } catch (error) {
        console.error("Error deleting billing address:", error);
      }
    
  };

  return (
    <>
    {showConfirmDialog && (
      <ConfirmDialog
        title={t("deleteAddressConfirmTitle")}
        message={t("deleteAddressConfirmMessage")}
        onCancel={() => {
        setShowConfirmDialog(false);
        
        }}
        onConfirm={() => {
        // Handle confirm logic here
        setShowConfirmDialog(false); // Close dialog after action
        handleConfirmedDelete();
     }}
      isOpen={showConfirmDialog}
    />
    )}
    <div
      className="mt-3 rounded-lg p-2 flex items-center justify-between mb-3"
      onClick={() => {
        if(isSelectable)
            onSelect?.(address)
      }}
      style={{
        backgroundColor: isSelected && isSelectable? (!isDarkMode? "#D9D9D9": "#2c2c2c" ): "transparent",
        boxShadow: isSelected && isSelectable? "0px 4px 4px rgba(0, 0, 0, 0.25)" : "none",
      }} 
    >
      <div className="flex items-center space-x-2 p-2">
        {isSelectable && 
        <div className="form-radio-outer circle-box-outer-pportfolio">
          <div
            style={{
              width: isSelected ? "8px" : "0",
              height: isSelected ? "8px" : "0",
              borderRadius: "50%",
              backgroundColor: `${buttonColor?? "#6B46C1"}`,
              transition: "width 0.2s, height 0.2s",
            }}
          />

        </div>
        }
        <span className=" ml-4 text-style-bold-pportfolio">
          {address.firstName} {address.lastName}, {address.address1}
          <br />
          <span className=" font-poppins font-semibold text-style-normal-pportfolio">
            {address.city}, {address.state}, {address.zipCode}, {address.country}.
          </span>
        </span>
      </div>

      <div className="flex items-center space-x-2">
        {isEditMode && isSelected ? (
          <>
            <button
              className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
              onClick={(e) => {
                e.stopPropagation();
                
                navigate("/billingaddresses", { replace:true, state: { address: address,returnurl:"/subscriptionpayment" } });
              }}
            >
              <img className="w-6 h-6 cursor-pointer" src={edit_icon} alt="Edit" />
            </button>
            <button
              className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
              onClick={(e) => {
                e.stopPropagation();
                //onDelete?.(address);
                setShowConfirmDialog(true);
              }}
            >
              <img className="w-6 h-6 cursor-pointer" src={delete_icon} alt="Delete" />
            </button>
            <button
              className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
              onClick={(e) => {
                e.stopPropagation();
                setIsEditMode(!isEditMode);
              }}
            >
             {closePoints(isDarkMode)}
            </button>
          </>
        ) : (
          isSelected && (
            <button
              className="text-gray-500 overflow-hidden whitespace-nowrap text-ellipsis"
              onClick={(e) => {
                e.stopPropagation();
                setIsEditMode(!isEditMode);
              }}
            >
             {vertPoints(isDarkMode)}
            </button>
          )
        )}
      </div>
    </div>
    </>
  );
};

export default BillingAddressCard;